import React from "react"

import './../../static/css/divider.css'

const Divider = ({ text }) => (
  <div className="or-container">
    <div className="or-separator"></div>
    {text}
    <div className="or-separator"></div>
  </div>
)

export default Divider